import { useEffect, useRef, useState } from "react";
import { useClickAway, useDebounce } from "react-use";
import { QuickSearchResult3, QuickSearchService } from "../api";
import { useStorefront } from "../hooks/useStorefront";
import { webComponentWithJsonProp } from "../services/webComponentService";
import { QuickSearchProps } from "../types/components/QuickSearchProps";
import QuickSearchForm from "./QuickSearch/QuickSearchForm";
import QuickSearchResult from "./QuickSearch/QuickSearchResult";

function QuickSearch({ searchPageUrl }: QuickSearchProps) {
	const storefront = useStorefront();
	const queryFromUrl =
		storefront.pageType === "searchPage"
			? (new URLSearchParams(window.location.search).get("q") ?? "")
			: "";
	const [searchResult, setSearchResult] = useState<QuickSearchResult3>();
	const [show, setShow] = useState(false);
	const [query, setQuery] = useState(queryFromUrl);
	const isFirstValue = useRef(true);
	const ref = useRef<HTMLDivElement>(null);

	function handleFocus() {
		setTimeout(() => {
			if (query && searchResult) {
				setShow(true);
			}
		}, 100); //TODO: Why the timeout?
	}

	useEffect(() => {
		setShow(searchResult !== undefined);
	}, [searchResult]);

	useClickAway(ref, () => setShow(false));

	useDebounce(
		async () => {
			// on the very first call, just flip the flag and bail out
			if (isFirstValue.current) {
				isFirstValue.current = false;
				return;
			}
			const trimmedQuery = query.trim();
			if (trimmedQuery.length > 0) {
				setSearchResult(undefined);
				const result = await QuickSearchService.search({ query: { Query: trimmedQuery } });
				setSearchResult(result.data);
				setShow(true);
			} else {
				setSearchResult(undefined);
				setShow(false);
			}
		},
		300,
		[query]
	);

	return (
		<div ref={ref} className="relative">
			<QuickSearchForm
				query={query}
				searchPageUrl={searchPageUrl}
				onChange={setQuery}
				onFocus={handleFocus}
			/>
			{show && searchResult && (
				<QuickSearchResult
					query={query}
					searchResult={searchResult}
					searchPageUrl={searchPageUrl}
				/>
			)}
		</div>
	);
}

export default webComponentWithJsonProp("quick-search", QuickSearch);
